import { gql } from '@apollo/client'
import fullObjectiveFragment from './ObjectiveDTO.fragment'

export const SAVE_OBJECTIVE = gql`
  mutation saveObjective($employeeId: HashedId!, $objective: ObjectiveInput!) {
    saveObjective(employeeId: $employeeId, objective: $objective) {
      ...fullObjectiveFragment
    }
  }
  ${fullObjectiveFragment}
`

export const SAVE_OBJECTIVE_IN_MEETING = gql`
  mutation saveObjectiveInMeeting($objective: ObjectiveInput!, $meetingId: HashedId!) {
    saveObjectiveInMeeting(objective: $objective, meetingId: $meetingId) {
      ...fullObjectiveFragment
    }
  }
  ${fullObjectiveFragment}
`

export const DISMISS_OBJECTIVE_IN_MEETING = gql`
  mutation DismissObjectiveInMeeting($id: HashedId!, $meetingId: HashedId!) {
    dismissObjectiveInMeeting(id: $id, meetingId: $meetingId)
  }
`

export const DELETE_OBJECTIVE_IN_MEETING = gql`
  mutation DeleteObjectiveInMeeting($globalId: String!, $meetingId: HashedId!) {
    deleteObjectiveInMeeting(globalId: $globalId, meetingId: $meetingId)
  }
`

export const REACTIVATE_OBJECTIVE_IN_MEETING = gql`
  mutation ReactiveObjectiveInMeeting($id: HashedId!, $meetingId: HashedId!) {
    reactiveObjectiveInMeeting(id: $id, meetingId: $meetingId)
  }
`

export const DUPLICATE_OBJECTIVE_IN_MEETING = gql`
  mutation DuplicateObjectiveInMeeting($globalId: String!, $meetingId: HashedId!) {
    duplicateObjectiveInMeeting(globalId: $globalId, meetingId: $meetingId)
  }
`

export const DUPLICATE_AND_DISMISS_OBJECTIVE_IN_MEETING = gql`
  mutation DuplicateAndDimissObjectiveInMeeting($objective: ObjectiveInput!, $meetingId: HashedId!) {
    duplicateAndDismissObjectiveInMeeting(objective: $objective, meetingId: $meetingId)
  }
`

export const CLOSE_OUTDATED_TARGETS = gql`
  mutation CloseOutdatedTargets($meetingId: HashedId!) {
    closeOutdatedTargets(meetingId: $meetingId)
  }
`

export default {
  SAVE_OBJECTIVE,
  SAVE_OBJECTIVE_IN_MEETING,
  DISMISS_OBJECTIVE_IN_MEETING,
  DELETE_OBJECTIVE_IN_MEETING,
  REACTIVATE_OBJECTIVE_IN_MEETING,
  DUPLICATE_AND_DISMISS_OBJECTIVE_IN_MEETING,
}
